import React, { useRef, useEffect } from 'react';
import { MapContainer, TileLayer, GeoJSON, useMap } from 'react-leaflet';
import L from 'leaflet';
import {
  List,
  ListItem,
  ListItemText,
  Typography,
  Box,
  ListItemIcon,
} from '@mui/material';

const GeoDropDown = ({ geometries, onGeometrySelect }) => {
	const mapRefs = useRef({});

	const ChangeView = ({ bounds }) => {
		const map = useMap();
		useEffect(() => {
		if (bounds) {
			map.fitBounds(bounds);
		}
		}, [bounds]);
		return null;
	};

	return (
		
		<Box sx={{ width: '250px', maxHeight: '100vh', overflowY: 'auto' }}>
		<div style={{ 
			display: 'flex', 
			alignItems: 'center', 
			padding: '10px', 
			backgroundColor: '#f0f0f0' 
		}}>
			<img 
				src="/logo-small.png" 
				alt="Logo" 
				style={{ height: '50px', marginRight: '20px' }} 
			/>
		</div> 
		<List>
            {geometries && geometries.length > 0 ? (
                geometries.map((feature) => {
                    let bounds = null;
                    if (feature.geometry) {
                        const geoJsonLayer = L.geoJSON(feature.geometry);
                        bounds = geoJsonLayer.getBounds();
                    }

                    return (
                        <ListItem
                            key={feature.geom_id}
                            onClick={() => onGeometrySelect(feature)}
                            sx={{ cursor: 'pointer', display: 'block' }}
                        >
                            <ListItemText
                                primary={feature.name}
                                sx={{ textAlign: 'left' }}
                            />
                            <ListItemIcon sx={{ justifyContent: 'center' }}>
                                <MapContainer
                                    key={`${feature.geom_id}-map`}
                                    center={
                                        feature.center && feature.center.coordinates
                                            ? feature.center.coordinates
                                            : [34.9167, 33.633]
                                    }
                                    zoom={5}
                                    style={{ width: 200, height: 150 }}
                                    whenCreated={(map) => (mapRefs.current[feature.geom_id] = map)}
                                >
                                    <TileLayer
                                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />
                                    <GeoJSON data={feature.geometry} />
                                    {bounds && <ChangeView bounds={bounds} />}
                                </MapContainer>
                            </ListItemIcon>
                        </ListItem>
                    );
                })
            ) : (
                <ListItem>
                    <ListItemText
                        primary="No geometries found"
                        sx={{ textAlign: 'center' }}
                    />
                </ListItem>
            )}
		</List>
		</Box>
	);
};

export default GeoDropDown;
